var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navigation'),_c('BottomNavigation',{staticClass:"d-flex d-md-none"}),_c('Snackbar',{key:"snackbar"}),_c('v-main',{staticClass:"brown lighten-5"},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_c('router-view',{staticClass:"fill-height no-gutters"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }